"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _formFields = require("@trodly/form-fields");

var _baseModule = _interopRequireDefault(require("./styles/base.module.css"));

var _Icons = require("../util/Icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var RegisterEnquiry =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RegisterEnquiry, _React$Component);

  function RegisterEnquiry() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RegisterEnquiry);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RegisterEnquiry)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "myEnquiries", function () {
      window.location.href = "/my-profile/enquiries";
    });

    return _this;
  }

  _createClass(RegisterEnquiry, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: _baseModule.default.container
      }, _react.default.createElement("div", {
        className: _baseModule.default.registerContainer
      }, _react.default.createElement("div", null, _react.default.createElement(_Icons.RequestSent, {
        width: "3rem"
      })), _react.default.createElement("div", {
        className: _baseModule.default.heading2
      }, "Enquiry sent")), _react.default.createElement("div", {
        className: "".concat(_baseModule.default.small, " ").concat(_baseModule.default.light),
        style: {
          marginBottom: "1.25rem"
        }
      }, "You will receive the response in Enquiries section in My Account."), _react.default.createElement("div", {
        className: "".concat(_baseModule.default.displayFlex, " ").concat(_baseModule.default.justifyContentEnd)
      }, _react.default.createElement(_formFields.Button, {
        text: "Done",
        type: "button",
        onClick: function onClick() {
          return window.location.reload();
        },
        className: "".concat(_baseModule.default.noMargin, " ").concat(_baseModule.default.marginRight)
      }), _react.default.createElement(_formFields.Button, {
        text: "Go to my Enquiries",
        type: "button",
        onClick: this.myEnquiries,
        className: _baseModule.default.noMargin
      })));
    }
  }]);

  return RegisterEnquiry;
}(_react.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userDetails: state.userDetails,
    members: state.members,
    comment: state.comment,
    enquiryFor: state.enquiryFor
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(RegisterEnquiry);

exports.default = _default;